import { render, staticRenderFns } from "./OsSurvey.vue?vue&type=template&id=795a0b67&scoped=true"
import script from "./OsSurvey.vue?vue&type=script&lang=ts"
export * from "./OsSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795a0b67",
  null
  
)

export default component.exports